import { api } from "@/lib/api";

// Flat platform fee (charged via Stripe card checkout) for an external Zelle/Venmo send.
export const EXTERNAL_FEE = 2;

// Save/replace/remove a recipient's Zelle/Venmo QR and/or handle.
// NOTE: the backend overwrites the QR field with whatever qr_data_url is sent, so when
// updating only a handle we must pass the CURRENT qr data url to preserve it.
export const updateMyQr = (method, qrDataUrl, opts = {}) =>
  api.patch("/recipients/me/qr", {
    method,
    qr_data_url: qrDataUrl || undefined, // string = save new QR; omit when only touching handle
    handle: opts.handle,
    clear_handle: !!opts.clearHandle,
    clear_qr: qrDataUrl === null,        // explicit "remove the saved QR"
  });

export const isPhoneish = (s) => {
  if (!s) return false;
  const digits = String(s).replace(/\D/g, "");
  if (digits.length < 7) return false;
  return /^[+\d\s().-]+$/.test(String(s).trim());
};

// Start a $2 fee checkout for an external send. success/cancel return to OUR web app.
export const createCheckoutExternal = ({ recipient_id, amount, method, message, anonymous }) => {
  const origin = window.location.origin;
  return api.post("/donations/create-checkout-external", {
    recipient_id,
    amount,
    method,
    message: message || undefined,
    anonymous: !!anonymous,
    success_url: `${origin}/donate/external`,
    cancel_url: `${origin}/donate/external`,
  });
};

export const getExternalDonation = (id) => api.get(`/donations/${id}/external`);
export const confirmExternal = (id) => api.post(`/donations/${id}/confirm-external`);
export const cancelExternal = (id) => api.post(`/donations/${id}/cancel-external`);

export const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

// Remember the external donation id across the Stripe redirect (fallback if the
// backend's return URL doesn't carry ?donation_id=).
const EXT_KEY = "blessed_external_pending";
const MAX_AGE_MS = 30 * 60 * 1000;

export const stashExternalPending = (id) => {
  if (!id) return;
  try { sessionStorage.setItem(EXT_KEY, JSON.stringify({ id, ts: Date.now() })); } catch {}
};
export const readExternalPending = () => {
  try {
    const raw = sessionStorage.getItem(EXT_KEY);
    if (!raw) return null;
    const { id, ts } = JSON.parse(raw);
    if (!id || Date.now() - ts > MAX_AGE_MS) { sessionStorage.removeItem(EXT_KEY); return null; }
    return id;
  } catch { return null; }
};
export const clearExternalPending = () => { try { sessionStorage.removeItem(EXT_KEY); } catch {} };
